import { initClientMap } from './GloboId'

initClientMap()